import { NeedTimeslice } from "../data/need";
import { parseDate } from "./dateUtils";

export { needToNeedDefinition } from "./needMath";

/**
 * Liefert den für `date` gültigen Bedarf einer Person – oder `undefined`,
 * wenn (noch) kein Bedarf hinterlegt ist. Caller müssen den Fehlfall
 * behandeln, damit kein falscher/leerer Zustand angezeigt wird.
 */
export function getNeedForDate(
  personNeeds: NeedTimeslice[] | undefined,
  date: string,
): NeedTimeslice | undefined {
  return (personNeeds ?? []).find(
    (need) =>
      parseDate(need.validFrom).getTime() <= parseDate(date).getTime() &&
      (need.validTo == undefined ||
        parseDate(need.validTo).getTime() > parseDate(date).getTime()),
  );
}
